import { render, staticRenderFns } from "./AddPPM_sixmonthly.vue?vue&type=template&id=75e81d25&scoped=true"
import script from "./AddPPM_sixmonthly.vue?vue&type=script&lang=ts"
export * from "./AddPPM_sixmonthly.vue?vue&type=script&lang=ts"
import style0 from "./AddPPM_sixmonthly.vue?vue&type=style&index=0&id=75e81d25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e81d25",
  null
  
)

export default component.exports